import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Select.scss';

const Select = ({ variantClasses = [], id, options, selected, inputChange, disabledKey = 'disabled', inputBlur = () => {}, isError = false, label = null, selectedPrefix = '' }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	const selectClasses = [s.select, s[`select__${id}`]];
	const labelClasses = [s.label];

	if (!Array.isArray(variantClasses)) variantClasses = [String(variantClasses)];
	variantClasses.filter((c) => !!c).forEach((c) => {
		if (c.indexOf('label') !== -1) labelClasses.push(s[c]);
		else selectClasses.push(s[c]);
	});

	if (isError) {
		selectClasses.push(s.select__error);
		labelClasses.push(s.label__error);
	}

	if (selected) {
		selectClasses.push(s.select__selected);
	}

	label = label || null;

	const select = (
		<div className={selectClasses.join(' ')}>
			<select name={id} id={id} onChange={inputChangeHandlar} onBlur={inputBlurHandlar} value={selected}>
				{
					options.map((option) => (typeof option === 'object' ? <option key={option.key} value={option.key} disabled={option[disabledKey] ? true : null}>{`${(selectedPrefix && option.key === selected ? selectedPrefix : '')}${option.value}`}</option> : <option key={option} value={option}>{option}</option>))
				}
			</select>
			<svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M8.07013 1.75472L6.27349 3.12736L5.34555 3.87734L4.19705 3.12729V3.11321L2.42987 1.75472L0 0V2.1934L5.24264 6L10.5 2.1934V0L8.07013 1.75472Z" />
			</svg>
		</div>
	);

	return (
		label ? (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				<span className={s.label_title}>{ label }</span>
				{ select }
				{ typeof isError === 'string' && <span className={s.select_errorText}>{ isError }</span> }
			</label>
		) : (
			<div>
				{ select }
			</div>
		)
	);
};

export default hot(module)(Select);
